import { FormObjType } from "DataTypes/Form";

export const VaccineForm: FormObjType[] = [
  {
    id: "productName",
    label: "Product Name",
    placeholder: "Enter Product Name",
    boxType: "input",
    boxSize: 3,
    validatetype: "name50",
    required: true,
    enableFormLoad: true,
  },
  {
    id: "dateTime",
    label: "Administered On",
    placeholder: "Select Date",
    boxType: "date",
    boxSize: 3,
    validatetype: "date",
    required: true,
    enableFormLoad: true,
  },
  {
    id: "routeName",
    label: "Administered Via",
    placeholder: "Enter Route Name",
    boxType: "input",
    boxSize: 3,
    validatetype: "name50",
    required: true,
    enableFormLoad: true,
  },
  {
    id: "doseQuantity",
    label: "Dose Quantity",
    placeholder: "Enter Dose Quantity",
    boxType: "input",
    boxSize: 3,
    validatetype: "alphaNum50",
    required: true,
    enableFormLoad: true,
  },
  {
    id: "doseUnits",
    label: "Dose Unit",
    placeholder: "Enter Dose Unit",
    boxType: "input",
    boxSize: 3,
    validatetype: "name50",
    required: true,
    enableFormLoad: true,
  },
]